import Cookies from 'js-cookie';

// "Recordar por 30 días": token que la API entrega al pasar el doble factor con la casilla
// marcada. Se manda en el siguiente login y, mientras no venza, la API ya no pide el código
// en este navegador (sigue pidiendo la contraseña). La API solo guarda su hash.
//
// Vive en una cookie de este sitio (no de la API) porque Safari y Brave bloquean las
// cookies de otro dominio. El nombre no revela qué es, a propósito.
const COOKIE = 'ah31';
const DAYS = 30;
const TOKEN_FORMAT = /^[A-Za-z0-9_-]{43}$/;
// Solo para esta app (publicPath '/signature'), no para el resto del dominio.
const COOKIE_PATH = (process.env.BASE_URL || '/').replace(/\/$/, '') || '/';

function write(token) {
  Cookies.set(COOKIE, token, {
    expires: DAYS,
    path: COOKIE_PATH,
    sameSite: 'lax',
    secure: window.location.protocol === 'https:'
  });
}

export const trustedDevice = {
  get() {
    try {
      const token = Cookies.get(COOKIE);
      return token && TOKEN_FORMAT.test(token) ? token : null;
    } catch (e) {
      return null;
    }
  },
  save(token) {
    try {
      if (token && TOKEN_FORMAT.test(token)) {
        write(token);
      }
    } catch (e) {
      // Sin cookies el navegador simplemente no queda recordado.
    }
  },
  // Safari borra en 7 días las cookies creadas desde JS si no se vuelven a escribir;
  // reescribirla al abrir el login la mantiene viva. La API vence el token a los 30 días
  // aunque la cookie dure más.
  touch() {
    const token = this.get();
    if (token) {
      this.save(token);
    }
  },
  clear() {
    try {
      Cookies.remove(COOKIE, { path: COOKIE_PATH });
    } catch (e) {
      // nada que limpiar
    }
  }
};
